import axios from "axios"
import { checkResponseStatus } from "./Utils"

export const sendWebVitals = async(name: string, value: number, rating: "good" | "needs-improvement" | "poor") => {
    try{
        await axios.post("api/metrics/web-vitals", {
            name,
            value,
            rating,
            page: window.location.pathname
        })
    } catch(error: any) {
        checkResponseStatus(error)
    }
}

export const sendFrontendErrorMetric = async (type: "javascript" | "promise") => {
    try{
        await axios.post("api/metrics/errors", {type})
    } catch(error: any) {
        checkResponseStatus(error)
    }
}